export function getBaseUrl () {
  let baseURL
  
  if (process.env.VUE_APP_LOCAL === 'true') {
    if (process.env.NODE_ENV === 'production') {
      return 'https://api.texasavesocial.com/api/v1/'
      // return 'https://fast-garden-02820.herokuapp.com/api/v1/'
    } else {
      return 'http://localhost:2222/api/v1/'
    }
  } else if (process.env.VUE_APP_LOCAL !== 'true') {
    if (process.env.NODE_ENV === 'production') {
      return 'https://<>/api/v1/'
    }
  }
  
  return baseURL
}

export function prepareRequestIndicators(commit, hasMessage = false) {
  commit('setError', false)
  commit('setIsLoading1', true)
  if (hasMessage) {
    commit('setResponseMsg', null)
  }
}

export function successRequestIndicators(commit, message = null) {
  commit('setError', false)
  commit('setIsLoading1', false)
  commit('setResponseMsg', message)
}

export function clearRequestIndicators(commit, error) {
  commit('setError', error)
  commit('setIsLoading1', false)
}
